import { useMemo } from 'react';
import { DataSource, RemoteSource } from '@components-common/types';
import { useApiUrlBuilder } from './use-api.hook';
import { useHttpClient, useNotifications } from '@hooks';
import { UseMutateFunction, useMutation, useQueryClient } from 'react-query';
import { saveErrorNotification,saveSuccessNotification } from '@dirootie-web/web-components-types';

export const useApiPut = <T>() => {
  const build = useApiUrlBuilder();
  const httpClient = useHttpClient();

  return useMemo(() => async (source: RemoteSource, payload: T) => {
    const url = build(source.url, source.urlParams);
    const res = await httpClient.put<T>(url, payload);
    return res.body;
  }, [build, httpClient]);
};

export const usePut = (): UseMutateFunction<any, unknown, { source: DataSource, payload: any }, unknown> => {
  const queryClient = useQueryClient();
  const put = useApiPut<any>(); // Adjust the type if needed
  const userNotificationService = useNotifications();

  return useMutation(
    ({ source, payload }: { source: DataSource, payload: any }) => put(source as RemoteSource, payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('source'); // Adjust the query key as needed
        userNotificationService.success(saveSuccessNotification);
      },
      onError: (err: any) => {
        userNotificationService.error(saveErrorNotification);
      },
    }
  ).mutateAsync;
};
